module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[50]537.49b5249.woff2";